"use client";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useInView } from "framer-motion";
import industriesBgImage from "../../../public/industries-bg.jpg";
import Image from "next/image";

const IndustriesSection = () => {
  const industries = [
    "Automotive",
    "Banking & Finance",
    "Education & E-Learning",
    "Fintech",
    "Healthcare",
    "Logistics",
    "Manufacturing",
    "Media & Entertainment",
    "Retail & E-Commerce",
    "Travel & Hospitality",
  ].sort();

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section
      id="industries"
      className="py-24 bg-gradient-to-br from-sky-700 to-sky-950 relative overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute inset-0 opacity-5">
        {/* Background Image with overlay */}
        <div className="absolute inset-0 z-0">
          <Image
            src={industriesBgImage}
            alt="Background"
            fill
            className="object-cover"
            quality={100}
            priority
          />
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-16"
        >
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-white mb-6"
            variants={itemVariants}
          >
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-100 to-cyan-500">
              Industries{" "}
            </span>
            We Serve
          </motion.h2>
          <motion.p
            className="text-xl text-white/90 max-w-3xl mx-auto"
            variants={itemVariants}
          >
            Tailored AI solutions for diverse industry verticals
          </motion.p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6"
          variants={containerVariants}
        >
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{
                y: -5,
                boxShadow: "0 10px 25px -5px rgba(14, 165, 233, 0.2)",
              }}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg text-sky-950 hover:text-white hover:bg-black/30 transition-all duration-300 border border-gray-200"
            >
              <div className="flex items-center">
                <h3 className="text-lg font-semibold">{industry}</h3>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* <motion.div className="mt-16 text-center" variants={itemVariants}>
          <motion.a
            href="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-sky-800 hover:bg-sky-700 transition-colors duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Industry-Specific Solutions
          </motion.a>
        </motion.div> */}
      </div>
    </section>
  );
};

export default IndustriesSection;
